import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { FormProvider, RHFTextField } from 'src/components';
import { Paths } from 'src/config';
import { useCreateContentTypeMutation } from 'src/redux/services/ContentTypeServices';
import * as Yup from 'yup';

const defaultValues = {
  name: '',
  slug: '',
};

const CourseCreateValidationSchema = Yup.object({
  name: Yup.string().required('نام اجباری می باشد'),
  slug: Yup.string().required('اسلاگ اجباری می باشد'),
}).required();

export const ContentTypeCreateForm = () => {
  const navigate = useNavigate();
  const [createContentType, { isLoading }] = useCreateContentTypeMutation();
  const methods = useForm({
    defaultValues,
    resolver: yupResolver(CourseCreateValidationSchema),
  });
  const { handleSubmit } = methods;

  async function onSubmit(values) {
    try {
      const body = {
        name: values.name,
        slug: values.slug,
      };
      await createContentType(body).unwrap();
      enqueueSnackbar(`نوع محتوا ${values.name} ایجاد شد`, { variant: 'success' });
      navigate(Paths.contentType.list.path);
    } catch (error) {
      console.log('CREATE CONTENT TYPE ERROR', error);
      if (error?.data?.err === `content type with slug ${values.slug} exists!`) {
        enqueueSnackbar(`نوع محتوا با اسلاگ ${values.slug} قبلا ایجاد شده است`, { variant: 'warning' });
      } else {
        enqueueSnackbar(`نوع محتوا ${values.name} ایجاد نشد`, { variant: 'error' });
      }
    }
  }

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <RHFTextField name={'name'} label={'نام'} />
        </Grid>
        <Grid item xs={6}>
          <RHFTextField name={'slug'} label={'اسلاگ'} />
        </Grid>
        <Grid item>
          <Button variant="contained" disabled={isLoading} type="submit">
            {Paths.contentType.create.title}
          </Button>
        </Grid>
      </Grid>
    </FormProvider>
  );
};
